export default {"src":"/_next/static/media/stressMotivation.12137132.svg","height":621,"width":1044,"blurWidth":0,"blurHeight":0};